export interface SavingsStat {
  id: string;
  /** Headline figure, e.g. "$500". */
  value: string;
  /** Supporting copy beneath the figure. */
  label: string;
}

/** Marketing figures shown on the homepage stats band and the July 4th hero. */
export const SAVINGS_STATS = [
  {
    id: 'average-savings',
    value: '$500',
    // The non-breaking space keeps "vs. Airbnb" together on one line.
    label: 'saved on average vs.\u00a0Airbnb',
  },
  {
    id: 'properties',
    value: '150K+',
    label: 'professionally managed properties',
  },
  {
    id: 'professional-managers',
    value: '100%',
    label: 'professional property managers',
  },
  { id: 'platform-markup', value: '$0', label: 'platform markup' },
] as const satisfies readonly SavingsStat[];

export type SavingsStatId = (typeof SAVINGS_STATS)[number]['id'];

/** Same-stay prices shown side by side in the homepage hero. */
export const HERO_PRICE_COMPARISON = {
  airbnb: '$3,166',
  savvy: '$2,625',
} as const;
